import axios from "axios";
import { LoginSignupModel } from "../../datamodels/auth/loginSignupModel";

export async function sendLoginEmailApiCall(
  passedEmail: string,
  passedMedium: boolean
) {
  const response = await axios.post<LoginSignupModel>(
    `/user/Auth/otp/register/login`,
    {
      email: passedEmail,
      actionMedium: passedMedium,
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
}
export async function sendLoginPhoneApiCall(
  passedCode: string,
  passedMobile: string,
  passedMedium: boolean
) {
  const response = await axios.post<LoginSignupModel>(
    `/user/Auth/otp/register/login`,
    {
      countryCode: passedCode,
      mobileNo: passedMobile,
      actionMedium: passedMedium,
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
}
